export default {
  NOTIFICATIONS_CENTRE: {
    NO_NOTIFICATIONS: 'No notifications to display',
    WIDGET: {
      TITLE: 'My notifications',
      EMPTY: 'There are no notifications yet.',
    },
    TYPES: {
      ACCOUNT_NOTIFICATION: 'Account notification',
      SYSTEM_UPDATE: 'System update',
      RESPONSE: 'Response',
      WHATS_NEW: "What's new",
      DOWNLOADS: 'Your Downloads',
      UPLOADS: 'Your Uploads',
    },
    DOWNLOAD: 'Download',
    NEW: 'New',
    READY_TO_DOWNLOAD: 'is ready to download',
  },
};
